import {inject, customElement, DOM} from 'aurelia-framework';
import {DialogController} from 'aurelia-dialog';
import {windowCentered} from '../../../../tools/dom';

@inject(DialogController, DOM.Element)
@customElement('message-box')
export class MessageBox {

  model: any;
  element: HTMLElement;

  constructor(public dialogController: DialogController, element: Element) {
    this.dialogController = dialogController;
    this.element = element as HTMLElement;
  }

  activate(model: any) {
    this.model = model;
  }
  attached() {
    let bodyParent = this.element.querySelector('ai-dialog-body');
    let body = DOM.createElement('div');
    body.innerHTML = ( this.model.message && this.model.message.innerHTML ) ? this.model.message.innerHTML : this.model.message;
    if (bodyParent && body) {
      DOM.appendNode(body, bodyParent);
    }
  }
  selectOption(option) {
    let optionText= option.text ? option.text : option;
    if (isCancel(optionText)) {
      this.dialogController.cancel(optionText);
    } else {
      this.dialogController.ok(optionText);
    }
  }
  center() {
    windowCentered(this.element);
  }
  close() {
    // @ts-ignore
    this.dialogController.close();
  }
}

function isCancel(option) {
  return ['cancel', 'no'].indexOf(option.toLowerCase()) !== -1;
}
